module.exports = __webpack_public_path__ + "static/media/heist_surveillance_van.4e5dee09.png";